"use client";

import Link from 'next/link';
import { PawPrint, Instagram, Facebook, Twitter } from 'lucide-react';

import Image from 'next/image';

export function Footer() {
  return (
    <footer className="bg-foreground text-primary-foreground pt-32 pb-12 relative overflow-hidden">
      {/* Decorative Wave at the top of footer */}
      <div className="absolute top-0 left-0 right-0 h-16 opacity-10">
        <Image src="/images/wave-decoration.png" alt="" fill className="object-cover object-top" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-4 gap-16 mb-24">
          <div className="col-span-2">
            <Link href="/" className="flex items-center gap-3 mb-8">
              <div className="p-2.5 bg-primary rounded-2xl text-primary-foreground shadow-lg">
                <PawPrint className="w-6 h-6" />
              </div>
              <span className="font-headline text-3xl font-black tracking-tight text-primary-foreground">
                Bay Valley<span className="text-primary-foreground/70 italic font-normal ml-1">Pups</span>
              </span>
            </Link>
            <p className="text-primary-foreground/70 max-w-sm leading-relaxed text-lg font-light">
              Raising ethically raised, healthy, and happy companion puppies in the heart of the Bay Area.
            </p>

            <div className="mt-12 relative w-32 h-32 opacity-20 hover:opacity-100 transition-opacity">
              <Image src="/images/maltipoo-character.png" alt="" fill className="object-contain" />
            </div>
          </div>

          <div>
            <p className="font-bold uppercase tracking-widest text-xs text-primary-foreground/80 mb-6">Quick Links</p>
            <ul className="space-y-4 text-sm text-primary-foreground/90">
              <li><Link href="/" className="hover:text-primary-foreground transition-colors">Home</Link></li>
              <li><Link href="/#available-puppies" className="hover:text-primary-foreground transition-colors">Available Puppies</Link></li>
              <li><Link href="/community" className="hover:text-primary-foreground transition-colors">Community Stories</Link></li>
              <li><Link href="/process" className="hover:text-primary-foreground transition-colors">Our Process</Link></li>
              <li><Link href="/about" className="hover:text-primary-foreground transition-colors">About Us</Link></li>
              <li><Link href="/contact" className="hover:text-primary-foreground transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-bold uppercase tracking-widest text-xs text-primary-foreground/80 mb-6">Connect</p>
            <div className="flex gap-4 mb-6">
              <a href="#" aria-label="Follow us on Instagram" className="p-2 bg-primary-foreground/10 rounded-full hover:bg-primary hover:text-primary-foreground transition-all">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" aria-label="Follow us on Facebook" className="p-2 bg-primary-foreground/10 rounded-full hover:bg-primary hover:text-primary-foreground transition-all">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" aria-label="Follow us on Twitter" className="p-2 bg-primary-foreground/10 rounded-full hover:bg-primary hover:text-primary-foreground transition-all">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
            <p className="text-xs text-primary-foreground/70">
              Follow us for daily puppy updates and news.
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-primary-foreground/10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-xs text-primary-foreground/60 font-medium">
            © {new Date().getFullYear()} Bay Valley Pups. Hand-crafted Excellence.
          </p>
          <div className="flex gap-8 text-[10px] uppercase tracking-widest font-bold text-primary-foreground/60">
            <Link href="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link href="/terms" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
